import { render, staticRenderFns } from "./FormasPagamentoPage.vue?vue&type=template&id=60fcce40&"
import script from "./FormasPagamentoPage.vue?vue&type=script&lang=js&"
export * from "./FormasPagamentoPage.vue?vue&type=script&lang=js&"
import style0 from "./FormasPagamentoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports